<template>
  <div
      v-if="mapLayerCount"
      class="d-flex flex-column rounded-1 bg-theme-transparent gmb-block--floating-box"
  >
    <GmbSection
        :childCheckboxActivatedValues="activatedMapLayerPks"
        :childCheckboxAllValues="mapLayerPks"
        :displayLevel="1"
        :disableSelectAllOrNoneButton="true"
        isCollapsible
        lockHeader
        title="Cartographie"
        @child-checkbox-activated-values-changed="
        (newActivatedMapLayerPks) =>
          $emit('activated-map-layers-changed', newActivatedMapLayerPks)
      "
    >
      <template #picto>
        <FdText colorTheme4 fa><i class="fas fa-road"/></FdText>
      </template>

      <template #infoSticker>
        <GmbSticker>{{
            activatedMapLayerCount + "/" + mapLayerCount
          }}
        </GmbSticker>
      </template
      >

      <GmbSection
          v-for="(mapLayerCategory, i) in mapLayerCategories"
          :displayLevel="2"
          isCollapsible
          :key="i"
          :title="mapLayerCategory.label"
      >
        <template #picto>
          <img :src="'/icons/' + mapLayerCategory.icon"/>
        </template>

        <template #infoSticker
        >
          <GmbSticker :text="mapLayerCountOfCategory(mapLayerCategory)"
          />
        </template>

        <GmbRow
            v-for="(mapLayer, j) in mapLayerCategory.mapLayers"
            :class="{ 'mt-2': j != 0 }"
            :controlValue="mapLayer.pk.toString()"
            isCheckbox
            :key="j"
        >
          <FdText tag="span">{{ mapLayer.label }}</FdText>
        </GmbRow>
      </GmbSection>
    </GmbSection>
  </div>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "MapLayers",

  components: {
    FdText,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  props: {
    activatedMapLayerPks: Array,
    mapLayerCategories: Array,
  },

  data() {
    return {};
  },

  computed: {
    activatedMapLayerCount() {
      return this.activatedMapLayerPks ? this.activatedMapLayerPks.length : 0;
    },

    mapLayerCount() {
      let count = 0;

      if (this.mapLayerCategories.length)
        this.mapLayerCategories.forEach((mapLayerCategory) => {
          count += mapLayerCategory.mapLayers.length;
        });

      return count;
    },

    mapLayerPks() {
      let pks = [];

      this.mapLayerCategories.forEach((mapLayerCategory) => {
        mapLayerCategory.mapLayers.forEach((mapLayer) => {
          pks.push(mapLayer.pk);
        });
      });

      return pks;
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    mapLayerCountOfCategory(mapLayerCategory) {
      return this.mapLayerCategories.length ? mapLayerCategory.length : 0;
    },
  },
};
</script>

<style lang="scss"></style>
